module.exports = __webpack_public_path__ + "static/media/gender.03234936.svg";